var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-plus-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5996 2.3999H7.19961C5.21138 2.3999 3.59961 4.01168 3.59961 5.9999V17.9999C3.59961 19.9881 5.21138 21.5999 7.19961 21.5999H10.9445C11.3238 21.5999 11.5693 21.191 11.4329 20.8371C11.1533 20.1118 11 19.3237 11 18.4999C11 14.91 13.9101 11.9999 17.5 11.9999C17.8615 11.9999 18.2162 12.0294 18.5617 12.0862C18.8865 12.1395 19.1996 11.9005 19.1996 11.5713V5.9999C19.1996 4.01168 17.5878 2.3999 15.5996 2.3999ZM7 4.99988C6.44772 4.99988 6 5.44759 6 5.99988C6 6.55216 6.44772 6.99988 7 6.99988H15.5C16.0523 6.99988 16.5 6.55216 16.5 5.99988C16.5 5.44759 16.0523 4.99988 15.5 4.99988H7ZM6 9.99988C6 9.44759 6.44772 8.99988 7 8.99988H13.5C14.0523 8.99988 14.5 9.44759 14.5 9.99988C14.5 10.5522 14.0523 10.9999 13.5 10.9999H7C6.44772 10.9999 6 10.5522 6 9.99988ZM7 12.9999C6.44772 12.9999 6 13.4476 6 13.9999C6 14.5522 6.44772 14.9999 7 14.9999H9C9.55228 14.9999 10 14.5522 10 13.9999C10 13.4476 9.55228 12.9999 9 12.9999H7Z",
    fill: "#3062D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7525 14.7795C18.7525 14.2272 18.3047 13.7795 17.7525 13.7795C17.2002 13.7795 16.7525 14.2272 16.7525 14.7795V17.1736L14.3583 17.1736C13.8061 17.1736 13.3583 17.6213 13.3583 18.1736C13.3583 18.7259 13.8061 19.1736 14.3583 19.1736H16.7525V21.5677C16.7525 22.12 17.2002 22.5677 17.7525 22.5677C18.3047 22.5677 18.7525 22.12 18.7525 21.5677V19.1736H21.1466C21.6988 19.1736 22.1466 18.7259 22.1466 18.1736C22.1466 17.6213 21.6989 17.1736 21.1466 17.1736L18.7525 17.1736V14.7795Z",
    fill: "#3062D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus02);
export default __webpack_public_path__ + "static/media/file-plus-02.2ad8a3de70334e27bc2b8d6d10f607c7.svg";
export { ForwardRef as ReactComponent };